import React from "react";
import {getPrincipaleOPrimoMacroGruppo} from "../../data/utils";
import AggsContainer from "./AggsContainer";
import MacrosContainer from "./MacrosContainer";

function PrematchBetGroupsNewAlt(props) {
  let macrogruppo = props.macrogruppo;
  if (props.macrogruppi.length > 0 && macrogruppo == null) {
    macrogruppo = getPrincipaleOPrimoMacroGruppo(props.macrogruppi);
  }
  const gruppiScommessa =
    macrogruppo != null ? macrogruppo.aggregate : props.aggregate;
  if (props.macrogruppi.length <= 1 && gruppiScommessa.length <= 1) {
    return null;
  }

  return (
    <div className="prematchbetgroupsnewalt__container">
      <div className="dropdown dropdown-menu-right">
        <button
          className="btn btn-secondary dropdown-toggle prematchbetgroupsnewalt__dropdown "
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {macrogruppo.descrizione}
        </button>
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          {props.macrogruppi.length > 1 && (
            <MacrosContainer
              current={macrogruppo.id}
              macros={props.macrogruppi}
              onClick={props.changeMacrogruppo}
            />
          )}
        </div>
      </div>
      <div className="macro-gruppi mb-2">
        {gruppiScommessa.length > 1 && (
          <AggsContainer
            current={props.aggregata}
            aggs={gruppiScommessa}
            onClick={props.changeAggregata}
          />
        )}
      </div>
    </div>
  );
}

export default PrematchBetGroupsNewAlt;
